const MAX_BYTES = 20 * 1024 * 1024;

export function isSandboxClassAssetZip(file: File): boolean {
    const name = file.name.toLowerCase();
    return name.endsWith('.zip') || file.type === 'application/zip' || file.type === 'application/x-zip-compressed';
}

export { MAX_BYTES as SANDBOX_CLASS_ASSET_MAX_BYTES };

/** @deprecated Prefer `uploadSandboxClassAssetZip` from redux/sandbox/actions via useDispatchPromise. */
export { uploadSandboxClassAssetZip } from '../redux/sandbox/actions';
